const REDIS_CACHE =
	process.env.NODE_ENV == 'production'
		? 'https://3cg1obtmoj.execute-api.us-west-2.amazonaws.com/checkout'
		: 'https://3cg1obtmoj.execute-api.us-west-2.amazonaws.com/checkout';

export default REDIS_CACHE;
